import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { BaseDashboardPage } from "../base/base-dashboard.page";
import { DashboardsService } from "../../shared/services/dashboards.service";
import { LaboratoryDashboardDataset } from "../../shared/models/dashboards/laboratory/laboratory-dashboard-dataset";
import { LaboratoryDashboardPerformer } from "../../shared/models/dashboards/laboratory/laboratory-dashboard-performer";
import { Observable } from "rxjs";
import { delay } from "rxjs/operators";

@Component({
    selector: 'laboratory-dashboard',
    templateUrl: './laboratory-dashboard.page.html',
    styleUrls: [
        './laboratory-dashboard.page.scss',
		'../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
		'../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../vendor/libs/ngx-contextmenu/ngx-contextmenu.scss',
	]
})
export class LaboratoryDashboardPage extends BaseDashboardPage implements OnInit, OnDestroy {

    defaultPerformerDashboardColor: string = '#7b96c9';
    pageSize: number = 6;
    pageNumber: number = -1;
    preloadSeconds: number = 2;

    intervalId: NodeJS.Timer;
    datasetLoading: boolean;

    currentTime: Date = new Date();
    datasetRequest: Observable<LaboratoryDashboardDataset> = null;
    dataset: LaboratoryDashboardDataset;
    currentPerformers: LaboratoryDashboardPerformer[] = [];

    constructor(
        private dashboardsService: DashboardsService
    ) { 
        super();
    }

    ngOnInit(): void {
        this.initDatasetLoading();
    }

    ngOnDestroy(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }

    initDatasetLoading() {
        this.dashboardsService.getLaboratoryDashboard().subscribe(dataset => {
            this.dataset = dataset;
            this.refreshPerformersPage();

            let preloadTimes = dataset.cycleDurationSeconds - this.preloadSeconds;
            let intervalTimes = 0;

            this.intervalId = setInterval(() => {
                this.currentTime = new Date(this.currentTime.getTime() + 1000);

                if (intervalTimes >= preloadTimes && !this.datasetLoading) {
                    this.datasetLoading = true;
                    let startTime = performance.now();

                    this.dashboardsService.getLaboratoryDashboard().subscribe(resp => {
                        let endTime = performance.now();
                        let duration = endTime - startTime;
                        let durationTime = duration < this.preloadSeconds * 1000
                            ? (this.preloadSeconds * 1000) - duration
                            : 0;

                        new Observable(subscriber => {
                            subscriber.next();
                            subscriber.complete();
                        })
                        .pipe(delay(durationTime))
                        .subscribe(() => {
                            this.dataset = resp;
                            this.refreshPerformersPage();
                            intervalTimes = 0;
                            this.datasetLoading = false;
                        });
                    });
                }
                else if (!this.datasetLoading) {
                    intervalTimes++;
                }
            }, 1000);
        });
    }
      
    refreshPerformersPage() {
        let performersCount = this.dataset.performers.length;

        if (this.pageNumber * this.pageSize + this.pageSize < performersCount) {
            this.pageNumber++;
        }
        else {
            this.pageNumber = 0;
        }

        let skip = this.pageNumber * this.pageSize;

        this.currentPerformers = this.dataset.performers.slice(skip, skip + this.pageSize);

        this.initAccordions();
    }
    
    initAccordions() {
        setTimeout(() => {    
            document.querySelectorAll('.request-indicator-accordion-trigger').forEach(trigger => {
                trigger.addEventListener('click', () => {
                    const content = trigger.nextElementSibling;
                    const isOpen = trigger.classList.toggle('active');
                    // цвет неизвестен, поэтому берем его из кнопки, где цвет задачется для каждого перформера
                    const nameElement = trigger.querySelector('.request-indicator-name') as HTMLElement;
                    const buttonElement = trigger.querySelector('.request-indicator-accordion-button') as HTMLElement;
                    
                    if (isOpen) {
                        content.classList.remove('closing');
                        content.classList.add('open');
                        trigger.classList.add('request-indicator-item-open');
                        nameElement.style.color = buttonElement.style.backgroundColor;
                    } 
                    else {
                        content.classList.remove('open');
                        content.classList.add('closing');
                        trigger.classList.remove('request-indicator-item-open');
                        nameElement.style.color = '#4e5155'
                        
                        content.addEventListener('transitionend', function handler() {
                            content.classList.remove('closing');
                            content.removeEventListener('transitionend', handler);
                        });
                    }
                });
            });
        }, 100);
    }

    getPerformerColor(performer: LaboratoryDashboardPerformer) {
        return performer.dashboardColor ? performer.dashboardColor : this.defaultPerformerDashboardColor;
    }
}